(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["seg-homepage-widget"] && !window.DesignMode) return;
  try {
    

	if(document.location.href.toString().indexOf("design_theme_id") > -1){
	    if(document.getElementById("sgm-section-homepage-reco-preview")){
		    document.getElementById("sgm-section-homepage-reco-preview").style.display = "block";
		}
	}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seg-product-widget"] && !window.DesignMode) return;
  try {
    

if(document.location.href.toString().indexOf("design_theme_id") > -1){
    if(document.getElementById("sgm-section-homepage-reco-preview")){
        document.getElementById("sgm-section-homepage-reco-preview").style.display = "block";
    }
}


  } catch(e) { console.error(e); }
})();

})();
